import { render, staticRenderFns } from "./BonusTypesPreviewComponent.vue?vue&type=template&id=0dc333a2&scoped=true"
import script from "./BonusTypesPreviewComponent.vue?vue&type=script&lang=js"
export * from "./BonusTypesPreviewComponent.vue?vue&type=script&lang=js"
import style0 from "./BonusTypesPreviewComponent.vue?vue&type=style&index=0&id=0dc333a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc333a2",
  null
  
)

export default component.exports